import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const EmptyCellValue = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="emptyCellValueDesc" /></Typography>
}

export default EmptyCellValue;